
    import infoList from './infoList.vue'
    import componentTitle from './componentTitle.vue'
    import {useStore} from "@/store";
    import {useRoute} from "vue-router";
    import {defineComponent, computed, ComputedRef, watch, reactive} from "vue";
    import  reportMsgUt from "@/util/reportMsg";

    interface State {
        dataList: object[];
        listSumNumber: number;
        reportMsg: object;
    }

    export default defineComponent({
        name: "configurationInfo",
        setup() {
            let state: State = reactive({
                dataList: [],
                listSumNumber: 0,
                reportMsg: {}
            })
            const {query} = useRoute();
            state.reportMsg = reportMsgUt;
            let store = useStore()
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo, (data: any) => {
                const {configureInfos} = data;
                state.dataList = configureInfos;
                state.listSumNumber = configureInfos.length;
            })
            return {
                state
            }
        },
        components: {
            infoList,
            componentTitle
        }
    })
